export default __webpack_public_path__ + "static/landmark_dark-496fa4fc3e99f5b8c6b0c4913e837906.svg";